import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Skeleton, Container } from "@mui/material";
import ScheduledAlertForm from "./ScheduledAlertForm";
import { getScheduledAlert, updateScheduledAlert } from "../../collections/scheduledAlerts";

const EditScheduledAlert = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    props.setPageTitle("Chỉnh sửa nhắc nhở");

    const fetchAlert = async () => {
      try {
        const alertData = await getScheduledAlert(id);
        setAlert(alertData);
      } catch (error) {
        console.error("Failed to fetch alert", error);
        toast.error("Không thể tải nhắc nhở", {
          position: "top-center",
          autoClose: 3000,
        });
        navigate("/scheduled-alerts");
      } finally {
        setLoading(false);
      }
    };

    fetchAlert();
  }, [id, navigate, props]);

  const handleUpdateAlert = async (formData) => {
    try {
      await updateScheduledAlert(id, formData);
      toast.success("Cập nhật nhắc nhở thành công!", {
        position: "top-center",
        autoClose: 2000,
      });
      navigate("/scheduled-alerts");
    } catch (error) {
      let errorMessage = "Đã xảy ra lỗi không xác định!";
      if (error.response?.data?.error) {
        const errorObj = error.response.data.error;
        if (typeof errorObj === "object") {
          errorMessage = Object.values(errorObj).flat().join("; ");
        } else {
          errorMessage = errorObj;
        }
      }
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  if (loading) {
    return (
      <Container sx={{ mt: 3 }}>
        <Skeleton animation="wave" variant="rectangular" height={400} />
      </Container>
    );
  }

  return (
    <ScheduledAlertForm
      onSubmit={handleUpdateAlert}
      initialData={alert}
      isEdit={true}
    />
  );
};

export default EditScheduledAlert;
